// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vIWU","col":"styles_col__U2U7X","actions":"styles_actions__1lRQF","conflict":"styles_conflict__XPqf-"};